import type { CruiseOffers, TransferOffer } from '@/model/upsell/transfer';

export function flattenTransferOffers(cruiseOffers: CruiseOffers): TransferOffer[] {
    return Object.values(cruiseOffers).flatMap((service) => Object.values(service.offers));
}
